<div class="flex-container">
	@if (treatment()) {
		<div data-cy="status">
			<h2>
				{{'Status' | translate}}
			</h2>
			<div class="subheader">
				{{ treatment().status | statusToString:true | translate }}
			</div>
			<div class="detail">
				{{ 'created at' | translate }}
				{{ treatment().created | date: 'mediumDate' : 'EUROPE/BERLIN' : config.locale }}
				<br>
				<span>{{'from' | translate}} {{customerSession().displayName}}</span>
				<br>
				@if (treatment().product.options; as options) {
					@if (options.uj && getToothAreaForProduct(true); as toothArea) {
						<span>
							{{'UJ' | translate}}: {{toothArea}}
						</span>
					}
					@if (options.lj && getToothAreaForProduct(false); as toothArea) {
						<span>
							{{'LJ' | translate}}: {{toothArea}}
						</span>
					}
					<br>
				}
			</div>
		</div>
	}

	<div data-cy="order-status">
		<h2>
			{{ 'Order' | translate }}
		</h2>
		<div class="subheader">
			{{ 'OrderId' | translate}}:
			{{ getQuotationOrOrderId() }}
		</div>
		<div class="detail">
			{{ 'ordered at' | translate }}
			{{ getCreatedDate() | date: 'mediumDate' : 'EUROPE/BERLIN' : config.locale }}
			@if (treatment().quotation?.salesOrders?.at(-1)?.docNum; as docNum) {
				<span><br>{{ 'Sales order' | translate}}: {{docNum}}</span>
			}<br>
		</div>

	</div>

	@if (patient() && customerSession()) {
		<div data-cy="patient-info">
			<h2>Patient</h2>
			<div class="subheader">
				{{patient().displayName}}
			</div>
			<div class="detail">
				{{'Id' | translate}}: {{patient().patientId}}<br>
				{{'created at' | translate}} {{patient().created | date: 'mediumDate' : 'EUROPE/BERLIN' : config.locale }}
				<br>
				{{'from' | translate}} {{customerSession().displayName}}<br>
			</div>
		</div>
	}
</div>

@if (pickUpInfo && !pickUpInfo.isExpired) {
	<div class="shipping-info-grid" [ngClass]="{'timeSlotActive' : pickUpInfo.isTimeSlotActive}">
		<div>
			<fa-icon [icon]="faUps"></fa-icon><strong> {{'UPS Abholung' | translate}}</strong><br>
			@if (!pickUpInfo.isTimeSlotActive) {
				{{'Paket sollte in' | translate}} {{pickUpInfo.timeUntilSlotIsActive?.hours}}
				{{'Stunden' | translate}} {{'und' | translate}}
				{{pickUpInfo.timeUntilSlotIsActive?.minutes}} {{'Minuten' | translate}} {{'abholbereit sein.' | translate}} <br>
			} @else {
				{{'Paket sollte ab jetzt abholbereit sein.' | translate}} <br>
			}
			<div>
				{{'PickupReferenceInfo' | translate}}: <strong>{{pickUpInfo.prn}}</strong>
			</div>
			<div>
				{{'Contact' | translate}}: {{pickUpInfo.address?.ContactName}},
				{{pickUpInfo.address?.CompanyName}},
				{{pickUpInfo.address?.PostalCode}} {{pickUpInfo.address?.City}},
				{{pickUpInfo.address?.AddressLine}},
				{{pickUpInfo.address?.Phone?.Number}}
			</div>
		</div>
		<div class="align-bottom">
			<lib-shipping-insert-print [treatment]="treatment()" [customer]="customerSession()"></lib-shipping-insert-print>
		</div>
	</div>
}

@if (treatment().status === TreatmentStatus.NewImprintsRequested
	&& treatment().product.options.dataTransfer === DataTransferMethod.OTHER) {
	<div class="shipping-info-grid">
		<div>
			<fa-icon [icon]="faBox"></fa-icon><strong> {{'Model shipping' | translate}}</strong><br>
			{{'ShippingHintAddress' | translate}}<br><br>
			<span class="shipping-address">{{shippingAddress}}</span><br><br>
			<button
				mat-raised-button
				ngxClipboard title="{{ 'CopyAddressToClipboard' | translate }}"
				[cbContent]="shippingAddress">
				<fa-icon [icon]="faCopy"></fa-icon> {{ "Zwischenablage" | translate }}
			</button>
		</div>
		<div class="align-bottom">
			<lib-shipping-insert-print [treatment]="treatment()" [customer]="customerSession()"></lib-shipping-insert-print>
		</div>
	</div>
}
